import { Box, Card, CardContent, Typography } from '@mui/material';
import type { ReactElement } from 'react';
import { ResponsiveContainer } from 'recharts';

type ChartCardProps = {
  title: string;
  description: string;
  children: ReactElement;
  height?: number;
};

/**
 * A chart in a card, with the axis and tooltip styling every chart here shares.
 *
 * It exists so that a second chart cannot quietly acquire different grid colours or a white tooltip in dark
 * mode — the failure that follows from copying a chart and editing it.
 */
export const ChartCard = ({ title, description, children, height = 288 }: ChartCardProps) => (
  <Card variant="outlined" sx={{ mt: 3 }}>
    <CardContent>
      <Typography variant="h6">{title}</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        {description}
      </Typography>
      <Box sx={{ height }}>
        <ResponsiveContainer width="100%" height="100%">
          {children}
        </ResponsiveContainer>
      </Box>
    </CardContent>
  </Card>
);
